import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Award, Droplet, Sparkles } from "lucide-react";
import { portalApi } from "@/lib/portalApi";

const ICONS = { graduation: Award, drops: Droplet, movement: Sparkles };
const drops = Array.from({ length: 14 }, (_, i) => i);

export default function Celebration() {
  const [queue, setQueue] = useState([]);
  const [i, setI] = useState(0);

  useEffect(() => {
    portalApi.get("/portal/celebrations").then((r) => setQueue(r.data.new || [])).catch(() => {});
  }, []);

  const cur = queue[i];
  if (!cur) return null;
  const Icon = ICONS[cur.kind] || Sparkles;

  const dismiss = async () => {
    await portalApi.post("/portal/celebrations/seen", { keys: [cur.key] }).catch(() => {});
    setI((n) => n + 1);
  };

  return (
    <div data-testid="celebration-modal" className="fixed inset-0 z-[60] bg-[#2A2825]/70 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {drops.map((d) => (
          <span key={d} className="op-drop absolute text-[#E8B486]" style={{ left: `${(d * 7 + 4) % 100}%`, top: "-10px", animationDelay: `${(d % 7) * 0.18}s`, fontSize: `${10 + (d % 4) * 4}px` }}>●</span>
        ))}
      </div>
      <div className="relative bg-[#F4EFE6] rounded-2xl max-w-md w-full p-8 md:p-10 text-center shadow-2xl" style={{ animation: "op-pop .5s cubic-bezier(.2,.8,.2,1)" }}>
        <div className="w-16 h-16 rounded-full bg-[#EAE3D9] flex items-center justify-center mx-auto mb-6">
          <Icon className="w-8 h-8 text-[#A9724E]" strokeWidth={1.25} />
        </div>
        <p className="tracking-overline text-[10px] uppercase text-[#A9724E] mb-3">A milestone</p>
        <h2 className="font-serif-display text-3xl text-[#2A2825] leading-tight mb-3">{cur.title}</h2>
        <p className="text-[#5E4B3C] font-body mb-8">{cur.subtitle}</p>
        {cur.kind === "graduation" ? (
          <Link to="/portal/certificate" onClick={dismiss} data-testid="celebration-certificate" className="inline-block rounded-full bg-[#A9724E] hover:bg-[#925C3B] text-[#F4EFE6] px-7 py-3 text-sm tracking-wide transition-colors">
            See your certificate
          </Link>
        ) : (
          <button onClick={dismiss} data-testid="celebration-continue" className="rounded-full bg-[#A9724E] hover:bg-[#925C3B] text-[#F4EFE6] px-7 py-3 text-sm tracking-wide transition-colors">
            Keep pouring
          </button>
        )}
      </div>
    </div>
  );
}
